<p-pickList [source]="sourceColumnList()" [target]="targetColumnList()" sourceHeader="Not Visible" targetHeader="Visible"
    [dragdrop]="true" [responsive]="true" filterBy="label" [showSourceControls]="false"
    (onMoveToSource)="updateOrder(); emitListUpdate()"
    (onMoveAllToSource)="updateOrder(); emitListUpdate()"
    (onMoveAllToTarget)="updateOrder(); emitListUpdate()"
    (onMoveToTarget)="updateOrder(); emitListUpdate()"
    (onSourceReorder)="updateOrder(); emitListUpdate()"
    (onTargetReorder)="updateOrder(); emitListUpdate()"
    (onSourceSelect)="updateOrder(); emitListUpdate()"
    (onTargetSelect)="updateOrder(); emitListUpdate()"
    [showTargetControls]="false" [metaKeySelection]="false">
    <ng-template let-column pTemplate="item">
        <div class="column-item w-100 h-100">
            <span class="col-handle"></span>
            <i class="col-order-badge">{{ column.order }}</i>
            <span class="column-label">{{column.label}}</span>
        </div>
    </ng-template>
</p-pickList>

    